import * as React from "react"
import { Box } from "@mui/material";

import {DateRangeBlock} from "@components";
import { DATE_PERIODS } from "@constants";
import {evolutionChartCurrentPeriod} from "../../@signals";
import {rangeDatesShareOfSearchDetails} from "./Ranges";


export default function ShareOfSearchKeywordEvolutionChartToolbar({dateRange, onChange}) {

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={evolutionChartCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesShareOfSearchDetails}
            onChange={onChange}
            onOk = { () => evolutionChartCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}


